import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const SCHEMA_VIEWER_PATH = '/api/schema-viewer';

const getEventList = async () => {
  const response = await axios.get(`${API_BASE_URL}${SCHEMA_VIEWER_PATH}/events`);
  return response.data.data;
};

const getEventSchema = async (eventName) => {
  const response = await axios.get(`${API_BASE_URL}${SCHEMA_VIEWER_PATH}/events/${eventName}`);
  return response.data.data;
};

const schemaViewerService = {
  getEventList,
  getEventSchema,
};

export default schemaViewerService;